<template>
  <div id="project-one-main-nav" class="grid-container fluid grid items-center border-b border-gray-20">
    <div v-if="showModelInfo" class="model-info">
      <h2 class="header--sm mb-0 mr-2" v-html="bikeData.modelName" />

      <trek-button
        id="summary-expand-button"
        text
        qaid="summary-expand-button"
        icon="expand_more"
        icon-right
        @click="showSummaryView"
      >
        <span v-if="isHidingPrices" v-html="bp('priceVaries')" />
        <span v-else-if="b2b && !consumerFriendlyMode" v-html="bikeData.calculatedDealerCost" />
        <span v-else v-html="bikeData.calculatedAdvertised" />
      </trek-button>
    </div>

    <project-one-logo :width="152" />

    <div v-if="bikeData.id || bikeData.p1ConfigPackageId" class="router-links overflow-hidden">
      <pdl-steps v-model="currentStep" non-linear @change="navigate">
        <pdl-steps-item
          v-for="link in activeLinks"
          :key="link.name"
          :qaid="`${link.name}-nav-link`"
          v-html="bp(link.name)"
        />
      </pdl-steps>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex';
import {PdlSteps, PdlStepsItem} from '@pedal/pdl-steps';
import ProjectOneLogo from '@/projectOne/components/navigation/ProjectOneLogo';
import TrekButton from '@/components/TrekButton';

export default {
  name: 'ProjectOneNav',

  components: {PdlSteps, PdlStepsItem, ProjectOneLogo, TrekButton},

  computed: {
    showModelInfo() {
      return this.$route.name !== 'chooseModel';
    },

    activeLinks() {
      if (this.navigation) {
        return this.navigation.filter((link) => {
          return link.isActive;
        });
      }
      return [];
    },

    currentStep: {
      get() {
        return this.currentNavigationStep;
      },
      set(value) {
        this.setCurrentNavigationStep(value);
      },
    },

    currentStepName() {
      if (Array.isArray(this.activeLinks) && this.activeLinks.length > this.currentStep) {
        return this.activeLinks[this.currentStep].name;
      }

      return null;
    },

    ...mapState('backend', ['b2b', 'consumerFriendlyMode']),
    ...mapState('projectOne', ['bikeData', 'navigation', 'currentNavigationStep', 'isHidingPrices']),
  },

  methods: {
    showSummaryView() {
      if (this.$route.name !== 'summary') {
        this.$router.push('summary');
      } else {
        if (window.history.length > 0) {
          this.$router.go(-1);
        }
      }
    },

    navigate() {
      const buildId = this.bikeData?.code || this.bikeData?.id;
      if (this.currentStepName) this.$router.push({name: this.currentStepName, params: {buildId: buildId}});
    },

    ...mapMutations('projectOne', ['setCurrentNavigationStep']),
  },
};
</script>

<style lang="scss" scoped>
.model-info {
  display: flex;
  margin-top: 1rem;
}

.project-one-logo {
  display: none;
}

@screen lg {
  #project-one-main-nav {
    grid-template-columns: 1fr 1fr;
  }

  .project-one-logo {
    display: block;
    margin-top: 1rem;
    grid-column: -1/-2;
    justify-self: end;
  }

  .router-links {
    grid-column: 1/3;
  }
}

@screen xxl {
  #project-one-main-nav {
    grid-template-columns: auto 1fr auto;
  }

  .model-info {
    margin-top: 0;
  }

  .project-one-logo {
    order: 3;
    margin-top: 0;
  }

  .router-links {
    order: 2;
    grid-column: -2/-3;
  }
}
</style>
